/** @jsx isolateComponent */
import { Colors } from '@zapier/theme';
import ListItem from '@zapier/design-system-company/src/components/ListItem';
import { Icon, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type Props = {
  /** Callback to be executed when the button is clicked */
  onClick: React.MouseEventHandler;
  /** The text to show as a link */
  text: string;
};

const Styles = labelStyles(__filename, {
  root: {
    ...Typography.altText900,
    alignItems: 'center',
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'space-between',
  },
  button: {
    cursor: 'pointer',
    width: '100%',

    ':hover': {
      color: Colors.blue500,
    },
  },
});

/**
 * A link to a specific topic in the `TrialWelcomeModal`.
 */
const TrialWelcomeModalTopicLink = (props: Props) => (
  <button css={Styles.button} onClick={props.onClick}>
    <ListItem size="small">
      <div css={Styles.root}>
        {props.text}
        <Icon name="arrowSmallRight" />
      </div>
    </ListItem>
  </button>
);

export default TrialWelcomeModalTopicLink;
